module.exports = __webpack_public_path__ + "static/dinosaurblanket-bcacfedb233a7f8b16d955fc4c4a7113.jpeg";